import { Aurelia, PLATFORM } from 'aurelia-framework';
export function configure(aurelia: any) {
	aurelia
		.globalResources(PLATFORM.moduleName('./battery-format'))
		.globalResources(PLATFORM.moduleName('./date-format'))
		.globalResources(PLATFORM.moduleName('./decimal-format'))
		.globalResources(PLATFORM.moduleName('./distance-format'))
		.globalResources(PLATFORM.moduleName('./dropdown-value-converter'))
		//.globalResources(PLATFORM.moduleName('./distance-value'))
		.globalResources(PLATFORM.moduleName('./degree-format'))
		.globalResources(PLATFORM.moduleName('./dielectric-permittivity-format'))
		.globalResources(PLATFORM.moduleName('./electrical-conductivity-format'))
		.globalResources(PLATFORM.moduleName('./filter-child-devices'))
		.globalResources(PLATFORM.moduleName('./filter-on-property'))
		.globalResources(PLATFORM.moduleName('./filter-structures-without-devices'))
		.globalResources(PLATFORM.moduleName('./gps-measurement-format'))
		.globalResources(PLATFORM.moduleName('./has-property-value'))
		.globalResources(PLATFORM.moduleName('./locations-to-delimited-string'))
		.globalResources(PLATFORM.moduleName('./soil-moisture-format'))
		.globalResources(PLATFORM.moduleName('./solar-radiation-format'))
		.globalResources(PLATFORM.moduleName('./sort-location-by-name'))
		.globalResources(PLATFORM.moduleName('./temperature-delta-format'))
		.globalResources(PLATFORM.moduleName('./temperature-delta-value'))
		.globalResources(PLATFORM.moduleName('./temperature-format'))
		//.globalResources(PLATFORM.moduleName('./temperature-value'))
		.globalResources(PLATFORM.moduleName('./humidity-format'))
		.globalResources(PLATFORM.moduleName('./moisture-format'))
		.globalResources(PLATFORM.moduleName('./precipitation-format'))
		.globalResources(PLATFORM.moduleName('./precipitation-total-format'))
		.globalResources(PLATFORM.moduleName('./pressure-format'))
		//.globalResources(PLATFORM.moduleName('./pressure-value'))
		.globalResources(PLATFORM.moduleName('./speed-format'))
		//.globalResources(PLATFORM.moduleName('./speed-value'))
		.globalResources(PLATFORM.moduleName('./has-data'))
		.globalResources(PLATFORM.moduleName('./split-word'))
		.globalResources(PLATFORM.moduleName('./tree-view-icon'))
		//.globalResources(PLATFORM.moduleName('./temperature-value'))
		.globalResources(PLATFORM.moduleName('./view-model-from-pascal-case'))
		.globalResources(PLATFORM.moduleName('./volumetric-water-content-format'));

}